export default __webpack_public_path__ + "locales/pt-BR/UploadPanel.json?hash=303dbdc1af90e9b97a23f61cfc0a191d";